import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

export const LoadingSpinner = ({ message }) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    const displayMessage = message || t('loadingProducts');

    return (
        <div className="admin-loading">
            <div className="loader"></div>
            <p>{displayMessage}</p>
        </div>
    );
}
// Exporting the component
export default LoadingSpinner;